<template>
  <div>
    <div>
      <div class="content-wrap">
        <div class="top-banner"></div>
        <div class="union-intro">
          <div class="container">
            <div class="intro-text">
              <div id="media" class="union-item">
                <h2>合作媒体</h2>
                <p>感谢一直以来支持我们的媒体！</p>
                <div class="line"></div>
                <div class="sy-partner-inner">
                  <div>
                    <p>
                      合作媒体
                      <span>(部分客户，排名不分前后)</span>
                    </p>
                    <img src="@/assets/img/partners/partner.png" />
                  </div>
                </div>
              </div>
              <div id="cooperationClient" class="union-item">
                <h2>合作客户</h2>
                <p>感谢支持与信任我们的客户！</p>
                <div class="line"></div>
                <div class="sy-partner-inner">
                  <div>
                    <p>
                      游戏类
                      <span>(部分客户，排名不分前后)</span>
                    </p>
                    <img src="@/assets/img/partners/partner-game.png" />
                  </div>
                  <div>
                    <p>
                      应用类
                      <span>(部分客户，排名不分前后)</span>
                    </p>
                    <img src="@/assets/img/partners/partner-app.png" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Parthners"
};
</script>

<style scoped>
.content-wrap {
  background-color: #f7f6fd;
}
.top-banner {
  width: 100%;
  height: 400px;
  background: url(../../assets/img/partners/banner.png) top no-repeat;
  background-size: cover;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 80px;
}

.intro-text {
  margin: 0 65px;
}

.intro-text > div {
  margin-top: 50px;
}

.sy-partner-inner {
  background-color: white;
}
.sy-partner-inner > div > p::before {
  width: 8px;
  height: 8px;
  background: rgba(199, 199, 199, 1);
  display: inline-block;
  content: "";
}
.sy-partner-inner > div > p {
  font-size: 14px;
  color: #333333;
  text-align: left;
  margin-left: 55px;
  padding-top: 20px;
}
.sy-partner-inner > div > p span {
  font-size: 12px;
  color: #999999;
}
.sy-partner-inner > div > img {
  margin-top: 10px;
  /* border: 1px dashed #000000; */
  margin-left: 50px;
  margin-bottom: 30px;
}

.union-item {
  /* border-bottom: 1px solid #eee; */
  padding-bottom: 20px;
  color: #282828;
  margin-bottom: 15px;
}

.union-item h2 {
  line-height: 45px;
  font-size: 36px;
  color: #333333;
  font-weight: bold;
  text-align: center;
}
.union-item p {
  font-size: 14px;
  line-height: 32px;
  text-align: center;
  color: #999999;
}
.line {
  width: 34px;
  height: 5px;
  background: rgba(0, 122, 255, 1);
  margin: 5px auto 40px;
}
</style>
